/**
 * In-app help-chat API (POST /ai/help-chat).
 */

import { apiClient } from './api-client';
import type { HelpChatTurn, HelpChatApiTurn, HelpChatResponse } from '@/types/help-chat.types';

/** Strip UI-only fields before POST /ai/help-chat. */
export function helpChatTurnsForApi(turns: HelpChatTurn[]): HelpChatApiTurn[] {
  return turns.map(({ role, content }) => ({ role, content }));
}

/** `POST /ai/help-chat` */
export async function postHelpChat(payload: {
  message: string;
  messages?: HelpChatApiTurn[];
}): Promise<HelpChatResponse> {
  const { data } = await apiClient.post<HelpChatResponse>('/ai/help-chat', payload);
  return {
    reply: data.reply,
    relatedSections: Array.isArray(data.relatedSections) ? data.relatedSections : [],
  };
}
